import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ForgotPasswordState {
  userName: string | null;
  token: string | null;
}

const initialState: ForgotPasswordState = {
  userName: null,
  token: null,
};

const forgotPasswordSlice = createSlice({
  name: 'forgotPassword',
  initialState,
  reducers: {
    setUserName: (state, { payload }: PayloadAction<string>) => {
      state.userName = payload;
    },
    setToken: (state, { payload }: PayloadAction<string>) => {
      state.token = payload;
    },
  },
});

const { reducer, actions } = forgotPasswordSlice;

// Actions
export const { setUserName, setToken } = actions;

export const forgotPasswordReducer = reducer;
